import { gql } from "@apollo/client";

export const LIST_VEHICLES = gql`
    query ListVehiclesGraphQL(
        $vehicleSearchTerm: String
        $filterInput: ListVehiclesFilterInput
        $first: Int
        $after: Cursor
        $stakeholderAndVehicleCenterInputs: [StakeholderAndVehicleCenterInput!]!
        $orderBy: VehicleOder
    ) {
        listVehicles(input: {
            stakeholderAndVehicleCenterInputs: $stakeholderAndVehicleCenterInputs
            vehicleSearchTerm: $vehicleSearchTerm
            first: $first
            after: $after
            filterInput: $filterInput
            orderBy: $orderBy
        }) {
            vehicles {
                id
                displayName
                photoUrl
              	Year: year
                Make: make
                Model: modelName
                OEM_ID: oemId
                Trim: trim
              	Odometer: odometer
              	last_booking:latestBooking {
                  id
                }
                status
                tier
                utilization
                totalBookings
                availableAt
                isDamaged
                licensePlate
                odometer
                exteriorColor
                interiorColor
                latestBooking {
                    scheduledReturnedAt
                }
              	VIN: vin
                V_ID: sourceVehicleId
                SH_ID: stakeholderId
                VMH_ID: vehicleManagementHubId
                gpsDevice {
                    id
                    name
                    deviceStatus {
                        isDeviceCommunicating
                    }
                }
            }
            metaData {
                first
                nextCursor
            }
            filterAggregations {
                oemIds
                stakeholderIds
                vehicleManagementHubIds
                tiers
                years
                makes
                vehiclesCount {
                    filtered
                    total
                }
                odometerRange {
                    min
                    max
                }
            }
        }
    }
`;

export const GET_VEHICLE = gql`
    query GetVehicle($id: Int!) {
        getVehicle(id: $id) {
            id
            active
            availableAt
            bookings {
                id
            }
            displayName
            fuelLevel
            isDamaged
            latestBooking {
                id
            }
            make
            modelName
            odometer
            oemId
            photoUrl
            specSheetUrl
            sourceVehicleId
            stakeholderId
            status
            terminatedAt
            scheduledTerminatedAt
            tier
            totalBookings
            trim
            uniqueTag
            utilization
            vehicleManagementHubId
            vin
            year

            licensePlate
            exteriorColor
            interiorColor
            keys
            warrantyDate
        }
    }
`;

export const GET_VEHICLE_BY_SOURCE_ID = gql`
    query GetVehicleBySourceVehicleId($sourceVehicleId: Int!) {
        getVehicleBySourceVehicleId(sourceVehicleId: $sourceVehicleId) {
            id
            active
            availableAt
            bookings {
                id
            }
            displayName
            fuelLevel
            isDamaged
            latestBooking {
                id
            }
            make
            modelName
            odometer
            oemId
            photoUrl
            specSheetUrl
            sourceVehicleId
            stakeholderId
            status
            terminatedAt
            scheduledTerminatedAt
            tier
            totalBookings
            trim
            uniqueTag
            utilization
            vehicleManagementHubId
            vin
            year

            licensePlate
            exteriorColor
            interiorColor
            keys
            warrantyDate
        }
    }
`;
